import { TulipModalController } from "../TulipModalController";

export class TulipModalWidget {

    parent: HTMLElement
    controller: TulipModalController | null = null;
    constructor(parent: HTMLElement, urlconfig: string, openAssetDetailCallback: CallableFunction, deliverable: any, user: any, designer: any) {
        this.parent = parent;
        this.parent.innerHTML = this.html();
        setTimeout(() => {
            this.controller = new TulipModalController(urlconfig, openAssetDetailCallback, deliverable, user, designer);
        }, 50);
    }

    htmlEditionTulip() {
        
    }

    html(): string {
        return `
            <div id="tulip-edition" style="display:flex;fex-wrap:no-wrap;justify-content:flex-start">
                <!-- Petals -->
                <div id="tulipEditionTabs" class="tulip-edition-tabs"></div>

                <!-- Properties panel (collapsable)-->
                <div id="properties-panel"></div>

                <!-- Component visualisation -->
                <div id="component-panel"></div>
            </div>
        `;
    }

    destroy() {
        this.controller!.destroy();
    }
}